import { render, staticRenderFns } from "./FreeEdit.vue?vue&type=template&id=cf94129e&scoped=true"
import script from "./FreeEdit.vue?vue&type=script&lang=js"
export * from "./FreeEdit.vue?vue&type=script&lang=js"
import style0 from "./FreeEdit.vue?vue&type=style&index=0&id=cf94129e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf94129e",
  null
  
)

export default component.exports